// UPDATE_THEME
export const UPDATE_THEME = 'UPDATE_THEME';
// FETCH_THEME
export const FETCH_THEME_SUCCESS = 'FETCH_THEME_SUCCESS';
export const FETCH_THEME_FAIL = 'FETCH_THEME_FAIL';
